import naja from 'naja'
import netteForms from 'nette-forms'

naja.uiHandler.selector = '.ajax-naja'
naja.formsHandler.netteForms = netteForms
naja.initialize()

import '../Styles/index.scss'
import './Naja/confirm'
import './Naja/redirect'
import './Naja/links'
import './Naja/toastr'
import '../Select2/Scripts/Select2'
import './DependentSelect/DependentSelect'